// extracted by mini-css-extract-plugin
var _1 = "e4ao6iEr4U6siwkYMOWu";
export { _1 as "questionTypeStyle" }
